import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { legendValid, legendValidInvalidRestart } from '../../utils/legend.data.util';
import { paymentMethodList, paymentMethodValue } from '../../libraries/payment.library';
import { prefixLegend } from '../../scripts/name.legend.script';

import AppLegend from './Legend';

export interface AppInputPaymentMethodProps {
  component?: string,
  solid: boolean,
  paymentMethod: {value: string, valid: boolean},
  setPaymentMethod: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setAccountingEntry?: Dispatch<SetStateAction<{value: string, valid: boolean, object: any}>>
};

const AppInputPaymentMethod: React.FunctionComponent<AppInputPaymentMethodProps> = ({component, solid, paymentMethod, setPaymentMethod, setAccountingEntry}) => {
  const {lang} = StateLanguage()

  const handleChangePaymentMethod = (item: string) => {
    setPaymentMethod({value: item, valid: true})
    legendValid(`${prefixLegend(component)}legend-payment-method-required`)

    if (setAccountingEntry) {
      setAccountingEntry({value: '', valid: false, object: null})
      legendValidInvalidRestart(`${prefixLegend(component)}legend-accounting-entry-required`)
    }
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
          <span className="selection">
            <span className="select2-selection select2-selection--single form-select">
              <span className={solid ? "select2-selection__rendered" : ""} role="textbox">
                {paymentMethod.valid ? paymentMethodValue(lang, paymentMethod.value) : lang.labels.selectOption}
              </span>
            </span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
          <span className="select2-dropdown select2-dropdown--below">
            <span className="select2-results">
              <ul className="select2-results__options" role="listbox">
                { paymentMethodList(lang).map (( (item, index) => { return (
                  <li key={index} className={`select2-results__option select2-results__option--selectable ${item.code === paymentMethod.value && "select2-results__option--selected"}`} role="option" aria-selected={item.code === paymentMethod.value}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangePaymentMethod(item.code)}>{item.display}</Dropdown.Item>
                  </li>
                )}))}
              </ul>
            </span>
          </span>
        </Dropdown.Menu>
      </Dropdown>
      <AppLegend component={component} attribute={{check: paymentMethod.valid, name: "payment-method", index: null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
    </>
  )
}

export default AppInputPaymentMethod;
